import { PageHeader } from "@/components/PageHeader";
import { Contact } from "@/components/Contact";
import { Instagram } from "@/components/Instagram";

export default function ContactPage() {
    return (
        <div data-testid="page-contact">
            <PageHeader
                number="C"
                label="Contact"
                title="Begin Your"
                accent="Design Journey."
                text="No forms, no waiting. Reach the studio directly on WhatsApp, by phone, or by email—we reply personally."
                testid="contact-page-header"
            />
            <Contact />
            <Instagram />
        </div>
    );
}
